import { Form, Formik, FastField } from 'formik'
import InputField from '../../customFields/InputField'
import * as Yup from 'yup'
import {
    FormGroup,
    GroupTitle,
    CenterItem,
    FixedLoading
} from './newsFormElements'
import EditorField from '../../customFields/EditorField'
import { SELECT_CATEGORY_OPTIONS } from '../../global'
import SelectField from '../../customFields/SelectField'
import FileField from '../../customFields/FileField'
import Button from '@material-ui/core/Button'
import { postNews, getSingleNews, updateNews } from '../../store/reducer/newsSlice'
import {useDispatch, useSelector} from 'react-redux'
import { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useHistory } from 'react-router-dom'
import AreaField from '../../customFields/AreaField'
import {useParams} from 'react-router-dom'

const NewsForm = ({type}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [uploading, setUploading] = useState(false)
    const { currentNews, currentNewsLoading } = useSelector(state => state.news)
    

    const {id} = useParams()

    useEffect(() => {

        if(type === 'update') {

            (async () => {
                try {
                    const actionResult = await dispatch(getSingleNews(id))
                    const result = unwrapResult(actionResult)
                    if(!result) history.push('/')
                } catch (error) {
                    console.log(error)
                    history.push('/')
                }
            })()

        }
        
    }, [dispatch, history, id , type])
    

    if(currentNewsLoading && type === 'update') return <FixedLoading><CircularProgress color="secondary" /></FixedLoading>



    const checkUploading = value => setUploading(value)


    const initialValues = {
        title: type === 'update' ? currentNews.title : '',
        description: type === 'update' ? currentNews.description : '',
        category: type === 'update' ? currentNews.category : '',
        author: type === 'update' ? currentNews.author : '',
        image: '',
        body: type === 'update' ? currentNews.body : '',
        highlight: type === 'update' ? currentNews.isHighLight : '',
    }

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Vui lòng nhập tiêu đề bài viết'),
        category: Yup.string().required('Vui lòng chọn thể loại bài viết'),
        author: Yup.string().required('Vui lòng nhập tên tác giả'),
        image: type !== 'update' && Yup.string().required('Vui lòng chọn ảnh đại diện'),
        description: Yup.string().required('Vui lòng nhập mô tả bài viết'),
        body: Yup.string().required('Vui lòng nhập nội dung bài viết'),
    })

    const handleSubmit = async (values, {resetForm, setFieldError}) => {
        const formData = new FormData()
        for (const key in values) {
            formData.append(key, values[key])
        }

        try {
            setUploading(true)
            const actionResult = type==='update' ? await dispatch(updateNews({ id, formData})) 
            : await dispatch(postNews(formData))
            const result = unwrapResult(actionResult)
            if(result.success) history.push('/admin/news')
            resetForm()
            setUploading(false)
        } catch (error) {
            console.log(error)
            setUploading(false)
        }
    }

    return (
        <>
            {uploading && <FixedLoading><CircularProgress color="secondary" /></FixedLoading>}
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {formikProps => {
                    
                    return (
                    <Form entype='multipart/form-data'>
                        <FormGroup style={{width: '400px'}}>
                            <GroupTitle>Tiêu đề</GroupTitle>
                            <FastField 
                                name="title"
                                component={InputField}
                                defaultval={currentNews.title}
                                type="text"
                                placeholder="Tiêu đề"
                            />
                        </FormGroup>
                        <FormGroup style={{width: '400px'}}>
                            <GroupTitle>Thể loại</GroupTitle>
                            <FastField 
                                name="category"
                                component={SelectField}

                                defaultval={currentNews.category}

                                options={SELECT_CATEGORY_OPTIONS}
                            />
                        </FormGroup>
                        <FormGroup style={{width: '400px'}}>
                            <GroupTitle>Nổi bậc</GroupTitle>
                            <FastField 
                                name="highlight"
                                component={SelectField}

                                defaultval={currentNews.isHighlight}

                                options={[{ value: false, label: 'Không' }, { value: true, label: 'Nổi bậc' }]}
                            />
                        </FormGroup>
                        <FormGroup style={{width: '400px'}}>
                            <GroupTitle>Tác giả</GroupTitle>
                            <FastField 
                                name="author"
                                component={InputField}

                                defaultval={currentNews.author}

                                type="text"
                                placeholder="Tác giả"
                            />
                        </FormGroup>
                        <FormGroup >
                            <GroupTitle>Ảnh đại diện</GroupTitle>
                            <FastField 
                                name="image"
                                component={FileField}

                            />
                        </FormGroup>
                        <FormGroup>

                            <GroupTitle>Mô tả</GroupTitle>
                            <FastField 
                                name="description"

                                defaultval={currentNews.description}

                                component={AreaField}
                                placeholder="Mô tả"
                            />
                        </FormGroup>
                        <FormGroup>

                            <GroupTitle>Nội dung</GroupTitle>
                            <FastField 
                                name="body"
                                defaultval={currentNews.body}
                                component={EditorField}
                                onUpload={checkUploading}
                            />
                        </FormGroup>
                        <CenterItem>
                            <Button type='submit' variant="contained" color="primary">{type === 'update' ? 'Xác nhận' : 'Đăng bài viết'}</Button>
                        </CenterItem>
                        
                    </Form>)
                }}
            </Formik>
        </>
    )
}

export default NewsForm
